import React, { useState } from "react";
import { useFormikContext } from "formik";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchVariant from "../../items/searchVariant";
import { formatDate } from "../../../../../utils/utils";
import { Badge, Table } from "react-bootstrap";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Typography } from "@material-ui/core";
function ConfirmUploadedStocks(props) {
  const { values, setFieldValue } = useFormikContext();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [itemID, setItemID] = useState(0);
  const [openSearchVariant, setOpenSearchVariant] = useState(false);
  const [editValue, setEditValue] = useState("");
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="card">
            <Table striped bordered size="sm" responsive="xl">
              {values && values.length > 0 ? (
                <thead>
                  <tr>
                    <th>Mass Upload Status</th>
                    <th>Item Code</th>
                    <th>Item Type</th>
                    <th>Item Name</th>
                    <th>Variant</th>
                    <th>Unit Name</th>
                    <th>Total Stock</th>
                    <th>Production Date</th>
                    <th>Expiry Date</th>
                  </tr>
                </thead>
              ) : null}
              <tbody>
                {values && values.length > 0 ? (
                  values.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item.statusID === 1 ? (
                          <Typography align="center">
                            <Badge variant="success" className="mx-1 my-1">
                              Ready To Upload
                            </Badge>
                          </Typography>
                        ) : item.statusID === 9 ? (
                          <React.Fragment>
                            <Typography align="center">
                              <span className="mr-3">
                                <BootstrapTooltip title={item.statusDesc}>
                                  <span className="mr-1">
                                    <i className="fas fa-exclamation-triangle kt-font-warning"></i>
                                  </span>
                                </BootstrapTooltip>
                                <Badge variant="danger" className="mx-1 my-1">
                                  Not Ready To Upload
                                </Badge>
                              </span>
                            </Typography>
                          </React.Fragment>
                        ) : null}
                      </td>
                      <td>{item.itemCode}</td>
                      <td>{item.itemTypeDesc}</td>
                      <td>{item.itemName}</td>
                      <td>
                        <>
                          {item.selectVariant ? (
                            item.varName === "" ||
                            editValue === `varName${index}` ? (
                              <FormArrayTextField
                                arrayPropName=""
                                index={index}
                                propName="varName"
                                margin="none"
                                searchButton
                                readonly
                                autoFocus
                                onSearchClick={() => {
                                  setSelectedIndex(index);
                                  setItemID(item.itemID);
                                  setOpenSearchVariant(true);
                                }}
                              />
                            ) : (
                              <React.Fragment>
                                <span className="mr-1">{item.varName}</span>
                                <span className="mx-1">
                                  <BootstrapTooltip title="Edit Variant">
                                    <button
                                      type="button"
                                      className="btn btn-icon btn-clean btn-circle btn-sm"
                                      onClick={() => {
                                        setEditValue(`varName${index}`);
                                      }}
                                    >
                                      <i className="fas fa-pencil-alt pr-0"></i>
                                    </button>
                                  </BootstrapTooltip>
                                </span>
                              </React.Fragment>
                            )
                          ) : null}
                        </>
                      </td>
                      <td>{item.uomName}</td>
                      <td>
                        {editValue === `totalStock${index}` ? (
                          <FormArrayTextField
                            arrayPropName=""
                            index={index}
                            propName="totalStock"
                            margin="none"
                            onBlur={(value) => {
                              setEditValue("");
                            }}
                            autoFocus
                          />
                        ) : (
                          <React.Fragment>
                            <span className="mr-1">{item.totalStock}</span>
                            <span className="mx-1">
                              <BootstrapTooltip title="Edit Total Stock">
                                <button
                                  type="button"
                                  className="btn btn-icon btn-clean btn-circle btn-sm"
                                  onClick={() => {
                                    setEditValue(`totalStock${index}`);
                                  }}
                                >
                                  <i className="fas fa-pencil-alt pr-0"></i>
                                </button>
                              </BootstrapTooltip>
                            </span>
                          </React.Fragment>
                        )}
                      </td>
                      <td>{formatDate(item.productionDate)}</td>
                      <td>{formatDate(item.expiryDate)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center py-3" colSpan="10">
                      <Illustration
                        imageSource="INVIFO Inventory.png"
                        guidance="You don't have any Stock items ready to be uploaded yet"
                        guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                        size="md"
                      ></Illustration>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchVariant}
        title="Search Variant"
        onCloseDialog={() => {
          setOpenSearchVariant(false);
        }}
        maxWIdth="sm"
      >
        <SearchVariant
          itemID={itemID}
          onCloseDialog={() => {
            setOpenSearchVariant(false);
          }}
          onSelectVariant={(varCode, valueName) => {
            setEditValue("");
            setFieldValue(`[${selectedIndex}].varCode`, varCode);
            setFieldValue(`[${selectedIndex}].varName`, valueName);
            setOpenSearchVariant(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default ConfirmUploadedStocks;
